"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EobHistoryTab = void 0;
const filter_header_1 = require("client/components/filter-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/eob/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./eob-history.less");
const moment = require("moment");
// id eh.id
// check# eh.checkNumber
// pharmacy eh.pharmacy
// payer eh.payer
// entry date eh.eobDate
// type ?
const columns = [
    {
        label: "id",
        id: "eh.id",
        className: "header-id"
    },
    {
        label: "check #",
        id: "eh.checkNumber",
        className: "header-checknum"
    },
    {
        label: "pharmacy",
        id: "eh.pharmacy",
        className: "header-pharm"
    },
    {
        label: "payer",
        id: "eh.payer",
        className: "header-payer"
    },
    {
        label: "entry date",
        id: "eh.eobDate",
        className: "header-date"
    },
    {
        label: "type",
        id: "eh.eob",
        className: "header-type"
    },
    {
        label: "source",
        id: "eh.source",
        className: "header-type"
    }
];
let EobHistoryTab = class EobHistoryTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.eobHistory = [];
        this.eobSiteId = 0;
        this.filterText = "";
        this.order = "DESC";
        this.orderBy = "eh.id";
        this.eobs = [];
        this.loadEobHeaders = throttle_debounce_1.debounce(200, async () => {
            await store_1.eobStore.loadEobs({
                count: 100,
                search: this.filterText,
                sort: this.orderBy,
                order: this.order,
                start: 0,
                siteId: this.eobSiteId
            });
        });
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadEobHeaders();
        };
        this.handleNewEntry = () => {
            store_1.eobStore.eobSelected = null;
            store_1.eobStore.showHistory = false;
            // RouteManager.transitionTo(`/eob/eobfees`);
        };
        this.onRequestSort = (property) => {
            // console.log("property is ", property);
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadEobHeaders();
        };
        this.handleChangeSite = async (id) => {
            this.eobSiteId = Number(id);
            this.loadEobHeaders();
        };
        this.renderOrderHistoryListRow = (row, index) => {
            const currentUser = store_3.usersStore.user ? store_3.usersStore.user.value : null;
            const { checkNumber, checkTotal, eobDate, id, payer, pharmacy, detail, eobTotal, EOB, source } = row;
            const siteName = pharmacy;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, onClick: this.handleShowHeader(row) },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: id }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: checkNumber }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(payer) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(eobDate).format("MM/DD/YYYY") }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: EOB === 1 ? "EOB" : "Payment", className: "eob-type" }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "eob-type", primary: source })));
        };
        this.handleShowHeader = (eob) => async () => {
            await store_1.eobStore.loadEob({ headerId: eob.id });
            eob.detail = store_1.eobStore.eob;
            store_1.eobStore.eobSelected = eob;
            callable_1.callable(this.props.handleEobSelect)();
            store_1.eobStore.showHistory = false;
            // console.log("showHistory is ", eobStore.showHistory);
            // console.log("eob selected is ", eob);
        };
        this.renderOrderHistoryList = () => {
            // console.log("this.eobs is ", this.eobs);
            const { value } = store_1.eobStore.eobs;
            // console.log("value from store is", value);
            return (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value || [], renderRow: this.renderOrderHistoryListRow, resizableheader: true, customClass: "custom-material-list__eob-history-list" }));
        };
    }
    get availableOptions() {
        return store_2.sitesListStore.sites.value
            ? store_2.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    componentWillMount() {
        store_2.sitesListStore.loadSitesNoRelation(); // @tkay load sites no relations
        this.eobSiteId =
            store_3.usersStore.user && store_3.usersStore.user.value && store_3.usersStore.user.value.siteId
                ? store_3.usersStore.user.value.siteId
                : 0;
        this.loadEobHeaders();
        this.eobs = store_1.eobStore.eobs.value;
    }
    render() {
        return (React.createElement("div", { className: "inventory-order__order-templates" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "EOB Details History"),
            React.createElement("div", { className: "order-templates__button" },
                React.createElement(button_1.MaterialButton, { onClick: this.handleNewEntry }, "Add New Entry")),
            React.createElement("div", { className: "group-management-container" },
                React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Search EOB Details", callBack: this.onCallback, filterText: this.filterText }),
                React.createElement("div", { className: "eob-change-view" },
                    React.createElement(select_1.MaterialSelect, { options: this.availableOptions, searchable: true, label: "Currently Viewing", onSelect: this.handleChangeSite, value: store_3.usersStore.user.value && store_3.usersStore.user.value.siteUser
                            ? store_3.usersStore.user.value.site.id.toString()
                            : String(this.eobSiteId)
                                ? String(this.eobSiteId)
                                : "" }))),
            this.renderOrderHistoryList()));
    }
};
__decorate([
    mobx_1.computed
], EobHistoryTab.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], EobHistoryTab.prototype, "eobHistory", void 0);
__decorate([
    mobx_1.observable
], EobHistoryTab.prototype, "eobSiteId", void 0);
__decorate([
    mobx_1.observable
], EobHistoryTab.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EobHistoryTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EobHistoryTab.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EobHistoryTab.prototype, "eobs", void 0);
__decorate([
    mobx_1.action
], EobHistoryTab.prototype, "onCallback", void 0);
__decorate([
    mobx_1.action
], EobHistoryTab.prototype, "handleChangeSite", void 0);
EobHistoryTab = __decorate([
    mobx_react_1.observer
], EobHistoryTab);
exports.EobHistoryTab = EobHistoryTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/eob/tabs/eob-history/eob-history.tsx
// module id = 3424
// module chunks = 0